import { AdminGuard } from "./admin.guard";

export * from "./admin.guard";

export const GUARDS = [
    AdminGuard,
];
